import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import { closeModal } from '@/store/common/actions';
import React, { SyntheticEvent } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import './style.scss';

interface MenuOption {
    name: string;
    icon: string;
    disabled: boolean;
    action: React.MouseEventHandler<HTMLButtonElement>;
}

const CourseMoreOptions: React.FC = () => {
    const { strings, course } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        course: state.lists.currentData.course,
    }));

    const dispatch = useDispatch();

    const history = useHistory();

    const limitTitleLength = 70;

    const dismissModalHandler = () => {
        dispatch(closeModal(Constants.modal.MORE_OPTIONS));
    };

    const clickOptionHandler = (f: Function) => (event: SyntheticEvent) => {
        event.stopPropagation();
        event.preventDefault();
        f(event);
    };

    const editList: React.MouseEventHandler<HTMLButtonElement> = clickOptionHandler(() => history.push(`/mine/courses/${course.id}/edit`));

    const manageList: React.MouseEventHandler<HTMLButtonElement> = clickOptionHandler(() => {
        localStorage.setItem('myCourseInEdition', `${course.id}`);
        return history.push({ pathname: `/mine/courses/${course.id}/suggestedContents` });
    });

    const options: MenuOption[] = [
        { name: strings.EDIT, icon: Constants.icons.EDIT, disabled: false, action: editList },
        { name: strings.MANAGE_ITEMS, icon: Constants.icons.LIST_ALT, disabled: false, action: manageList },
    ];

    const getName = (): string => {
        const { name } = course;
        return name.length > limitTitleLength ? `${name.substring(0, limitTitleLength)}...` : name;
    };

    return (
        <div className="course-more-options">
            <Modal.Header className="modal-header" closeButton onHide={dismissModalHandler}></Modal.Header>
            <Modal.Body>
                <div className="menu-container">
                    <div className="menu-sub-header">
                        <div className="label">{strings.LIST}</div>
                        <div>
                            <img alt="" className="img-menu" src={course.mainImage} />
                        </div>
                        <div className="name">{getName()}</div>
                    </div>
                    <div className="menu-items">
                        {options.map(({ icon, name, disabled, action }, index) => (
                            <button className="btn btn-link" disabled={disabled} key={index} onClick={action}>
                                <div className="item" key={index}>
                                    <i className="material-icons align-middle btn-link" key={index}>
                                        {icon}
                                    </i>
                                    <span>{name}</span>
                                </div>
                            </button>
                        ))}
                    </div>
                </div>
            </Modal.Body>
        </div>
    );
};

export default CourseMoreOptions;
